(($, Drupal) => {
  Drupal.behaviors.linksBlock = {
    attach: function attch(context) {
      $('.links-wrapper', context).once('accordion').each((index, element) => {
        $('.js-links').on('click', function (e) {
          e.preventDefault();
          const tab_id = $(this).attr('data-link');


          if (window.matchMedia('(min-width: 768px)').matches) {
            if ($(this).hasClass('active')) {
              $(this).removeClass('active');
              $(this).parents('.links-wrapper').find(tab_id).removeClass('active');
            } else {
              $(this).parents('.links-list').find('.js-links').removeClass('active');
              $(this).parents('.links-wrapper').find('.links-content').removeClass('active');
              $(this).addClass('active');
              $(this).parents('.links-wrapper').find(tab_id).addClass('active');
            }
          }

          if (window.matchMedia('(max-width: 1024px)').matches) {
            $(this).toggleClass('active');
            $(this).parents('.links-wrapper').find(tab_id).toggleClass('active');
          }
          e.stopImmediatePropagation();
        });
      });
    },
  };
})(jQuery, Drupal);
